import {useMutation} from '@tanstack/react-query';
import ChessPaymentRestClient from '@/Api/ChessPaymentRestClient';

export interface CsocPlayerIdentityPlayer {
  player_id: number;
  player_name: string;
}

export interface CsocPlayerIdentityResponse {
  state: 'attached' | 'pick_one' | 'fresh';
  attached_player: CsocPlayerIdentityPlayer | null;
  players: CsocPlayerIdentityPlayer[];
}

export default function useCsocPlayerIdentity(
  handleOnSuccess?: (data: CsocPlayerIdentityResponse) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<CsocPlayerIdentityResponse, Error, string>(
    async mobile_number => {
      const response = await ChessPaymentRestClient.post(
        'v1/csoc_player_identity',
        {mobile_number},
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
